<template>
  <el-dialog
    :title="title"
    :visible="
      (visibleModalName !== null &&
        visibleModalName === 'UploadSuccessPaymentsFromBank') ||
      visibleModalName === 'UploadFailPaymentsFromBank'
    "
    append-to-body
    :width="isMobile ? '90%' : '40%'"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <loader-wrapper :loading="loading">
      <h3 class="import-h3">
        Выберите файл импорта и нажмите кнопку загрузить
      </h3>
      <el-upload
        ref="upload"
        accept=".txt"
        :multiple="false"
        :auto-upload="false"
        :http-request="customUpload"
        action=""
      >
        <el-button slot="trigger" size="small" type="primary">
          Выберите файл
        </el-button>
        <el-button
          type="success"
          size="small"
          :loading="loading"
          style="margin-left: 10px"
          @click="onSubmit"
        >
          Загрузить
        </el-button>
      </el-upload>
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapMutations } from 'vuex'
import { paymentMenuItems } from '@/views/TableOfPayments/constants'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Payments = RepositoryFactory.get('payments')

export default {
  name: 'UploadPaymentBankModal',
  components: { LoaderWrapper },
  props: {
    visibleModalName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      title: '',
      status: null,
      requestLoading: false,
    }
  },
  methods: {
    ...mapMutations('tableOfPayments', ['updatePaymentsData']),

    beforeClose() {
      this.$emit('close')
      this.loading = false
      this.title = ''
      this.status = null
      this.requestLoading = false
    },
    customUpload(file) {
      this.loading = true
      const param = new FormData()

      param.append('file', file.file)
      param.append('status', this.status)
      Payments.updateDates(param)
        .then(res => {
          if (res.status === 200) {
            this.$nextTick(() => this.updatePaymentsData(res.data.result))
            this.$message.success('Файл успешно загружен')
            this.$refs.upload.clearFiles()
            this.beforeClose()
          }
        })
        .catch(e => this.errHandler(e))
        .finally(() => (this.loading = false))
    },
    onSubmit() {
      this.$refs.upload.submit()
    },
    beforeOpen() {
      let modal = paymentMenuItems.filter(
        item => item.name === this.visibleModalName,
      )

      this.status = modal[0].typePayment

      this.title = modal[0].title
    },
  },
}
</script>

<style lang="sass">
.import-h3
  font-family: "Rubik", sans-serif
  font-weight: normal
</style>
